<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<nav class="gm-navbar" role="navigation">
   <div class="navbar-header">
     <button type="button" class="sidebar-toggle" (click)="toggleSidebar()">
       <span class="sr-only">Toggle sidebar</span>
       <i class="fa fa-bars" aria-hidden="true"></i>
     </button>
     <a class="navbar-left navbar-image hidden-xs hidden-sm" routerLink='/'>
       <img src="../assets/images/GM-Flat.svg">
     </a>
     <span class="navbar-brand"><span class="title" routerLink=''>{{'ApplicationTitle' | translate}}</span></span>
   </div>

   <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
     <ul class="nav navbar-nav navbar-right">
       <li>
         <Select class="navbar-text navbar-date hidden-xs" style="color: black;" (change)="switchLanguage($event)">
           <option [selected]="userLanguageSession==='en'" value="en">{{ 'English' | translate }}</option>
           <option [selected]="userLanguageSession==='pt'" value="pt">{{ 'Portuguese' | translate }}</option>
           <option [selected]="userLanguageSession==='ch'" value="ch">{{ 'Chinese' | translate }}</option>
           <option [selected]="userLanguageSession==='ko'" value="ko">{{ 'Korean' | translate }}</option>
         </Select>
       </li>
       <li>
       <span class="navbar-text navbar-date hidden-xs">{{currentDate| date:'MM/dd/yyyy'}}</span>
       </li>
     </ul>
   </div>
 </nav>

